import { type RGBA, isDark } from '../lib/color';
import { contrastRatio } from '../lib/wcag';
import { t } from '../lib/i18n';

export interface ContrastRef {
  root: HTMLElement;
  update: (c: RGBA) => void;
}

export function createContrast(initial: RGBA): ContrastRef {
  const root = document.createElement('section');
  root.className = 'contrast';

  const title = document.createElement('div');
  title.className = 'contrast__title';
  title.textContent = t('Contrast');

  const samples = document.createElement('div');
  samples.className = 'contrast__samples';

  // 两个示例背景：白和黑
  const bgOptions: { label: string; bg: RGBA }[] = [
    { label: t('White BG'), bg: { r: 255, g: 255, b: 255, a: 1 } },
    { label: t('Black BG'), bg: { r: 0, g: 0, b: 0, a: 1 } }
  ];

  const cells: { swatch: HTMLElement; ratioEl: HTMLElement; aaa: HTMLElement }[] = [];
  for (const opt of bgOptions) {
    const cell = document.createElement('div');
    cell.className = 'contrast__cell';

    const swatch = document.createElement('div');
    swatch.className = 'contrast__swatch';
    swatch.style.background = `rgb(${opt.bg.r}, ${opt.bg.g}, ${opt.bg.b})`;

    const text = document.createElement('span');
    text.className = 'contrast__text';
    text.textContent = t('Aa Text Preview');
    text.style.color = isDark(initial) ? '#fff' : '#000';
    swatch.appendChild(text);

    const ratioEl = document.createElement('div');
    ratioEl.className = 'contrast__ratio';

    const aaa = document.createElement('div');
    aaa.className = 'contrast__badges';

    cell.append(swatch, ratioEl, aaa);
    samples.appendChild(cell);
    cells.push({ swatch, ratioEl, aaa });
  }

  root.append(title, samples);

  function update(c: RGBA): void {
    title.textContent = t('Contrast');
    cells.forEach((cell, i) => {
      const bg = bgOptions[i].bg;
      const ratio = contrastRatio(c, bg);
      cell.ratioEl.textContent = `${ratio.toFixed(2)} : 1 · ${bgOptions[i].label}`;
      cell.aaa.innerHTML = '';
      const aa = document.createElement('span');
      aa.className = 'badge ' + (ratio >= 4.5 ? 'badge--ok' : 'badge--no');
      aa.textContent = `AA ${ratio >= 4.5 ? '✓' : '✗'}`;
      const aaa = document.createElement('span');
      aaa.className = 'badge ' + (ratio >= 7 ? 'badge--ok' : 'badge--no');
      aaa.textContent = `AAA ${ratio >= 7 ? '✓' : '✗'}`;
      cell.aaa.append(aa, aaa);
      const text = cell.swatch.querySelector('.contrast__text') as HTMLSpanElement;
      text.style.color = isDark(c) ? '#fff' : '#000';
    });
  }

  update(initial);
  return { root, update };
}
